import React from 'react';
import type { TextT } from '@mentimeter/ragnar-ui/text';
import { Heading } from './Heading';

export const H4 = (props: TextT) => (
  <Heading as="h4" fontSize="125" {...props} />
);
